<dialog
  #dialogElement
  (click)="dialogListener()"
  class="dialog"
  [ngClass]="{
    'fade-out': !dialogIsOpen,
    'fade-in': dialogIsOpen
  }"
>
  <div
    class="dialog-content-wrapper"
    (click)="$event.stopPropagation()"
    *ngIf="dialogIsOpen"
  >
    <div
      class="dialog-content"
    >
      <button
        (click)="closeDialog()"
      >
        !!!
      </button>

      <ng-content>
      </ng-content>
    </div>
  </div>
</dialog>
